/*
  Разбор рассылки сообщений - §3.5.5, §3.11.5.

  Перенесён 06.10.2026 из карточки «Рассылка сообщений» в окно «Отправить СМС»
  экрана обзвона (вариант Б): карточка рассылала всей зоне «работа с
  должником», окно - тем, кого человек отметил в таблице. Сам разбор не
  изменился.

  Цена стоит последней, но узнаётся ДО отправки: длинный текст уходит
  несколькими частями, и волна на девятьсот счетов дорожает кратно.

  **Сам текст сообщения не показывается - решение владельца 08.09.2026.**
  Слова, уходящие должнику, читает и подписывает юрист Арбитра ЖКХ; оператору
  остаётся выбор формулировки по названию, охват и цена.
*/

import { Link } from 'react-router-dom'

import { accounts as accountsWord, money } from '../api/format.js'
import { Notice, Tag } from './Common.jsx'
import PageBar from './PageBar.jsx'
import usePaging from './usePaging.js'

export default function MessagePlan({ plan }) {
  const reasons = Object.entries(plan.skipped_by_reason)
  // 21.10.2026: пропущенных счетов в волне бывают сотни - причина по каждому листается
  // общей панелью страниц. Сводка «причина - число» выше - итог, её не листаем.
  const { rows: skipped, bar } = usePaging(plan.skipped)
  return (
    // `stack` задаёт разбору тот же вертикальный ритм, что карточке: без него у
    // каждого блока был бы свой отступ, подобранный на глаз.
    <div className="stack">
      <div className="row">
        <Tag kind="calm">уйдёт: {plan.drafts.length}</Tag>
        <Tag kind="muted">пропущено: {plan.skipped.length}</Tag>
        <Tag kind="warn">частей: {plan.segments_total}</Tag>
        {plan.cost ? <Tag kind="muted">{money(plan.cost)}</Tag> : null}
      </div>
      <div className="muted">{plan.cost_explanation}</div>

      {plan.length_notice ? (
        <Notice kind="warn">
          <div className="notice__what">Не все сообщения уйдут выбранными словами.</div>
          <div className="notice__do">{plan.length_notice}</div>
        </Notice>
      ) : null}

      {plan.channel_blocked ? (
        <Notice kind="warn">
          <div className="notice__what">Отправить нечем: {plan.channel_blocked}</div>
          <div className="notice__do">
            Разбор при этом посчитан: охват и цена нужны как раз до разговора с оператором связи.
          </div>
        </Notice>
      ) : null}
      {plan.release_blocked ? (
        <Notice kind="warn">
          <div className="notice__what">Эти слова отправлять нельзя.</div>
          <div className="notice__do">{plan.release_blocked}</div>
        </Notice>
      ) : null}

      {reasons.length ? (
        <table className="table">
          <tbody>
            {reasons.map(([reason, count]) => (
              <tr key={reason}>
                <td>{reason}</td>
                <td className="table__num">{count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : null}

      {plan.skipped.length ? (
        <details>
          <summary className="muted">Показать причину по каждому счёту</summary>
          <div className="log">
            {skipped.map((item) => (
              <div className="log__row" key={item.account_id}>
                <Link className="log__when" to={`/accounts/${item.account_id}`}>
                  счёт {item.account_number || ''}
                </Link>
                <span>{item.explanation}</span>
              </div>
            ))}
          </div>
          <PageBar {...bar} what="счетов" />
        </details>
      ) : null}

      <div className="muted">
        Текст формулировки здесь не показывается: слова, уходящие должнику, читает и подписывает
        юрист Арбитра ЖКХ. Разобрано {accountsWord(plan.drafts.length + plan.skipped.length)}.
      </div>
    </div>
  )
}
